var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHintError({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#F90606"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5C15.866 5 19 8.13401 19 12ZM8.68361 15.4022C8.29309 15.0116 8.29309 14.3785 8.68361 13.9879L10.5598 12.1117L8.79035 10.3422C8.39983 9.95168 8.39983 9.31852 8.79035 8.92799C9.18088 8.53747 9.81404 8.53747 10.2046 8.92799L11.9741 10.6975L13.8316 8.83999C14.2221 8.44947 14.8552 8.44947 15.2458 8.83999C15.6363 9.23052 15.6363 9.86368 15.2458 10.2542L13.3883 12.1117L15.1543 13.8777C15.5448 14.2683 15.5448 14.9014 15.1543 15.292C14.7638 15.6825 14.1306 15.6825 13.7401 15.292L11.9741 13.5259L10.0978 15.4022C9.7073 15.7927 9.07414 15.7927 8.68361 15.4022Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHintError);
export default __webpack_public_path__ + "static/media/hint-error.8f572ac462954365826d22cb57fe08c5.svg";
export { ForwardRef as ReactComponent };